module.exports = __webpack_public_path__ + "static/img/qq_6.f65f7954.png";